<div class="alert-monitoring-result">
  <div *ngIf="!response()?.success" class="error-state">
    {{ response()?.error || ('COMMON.ERROR' | translate) }}
  </div>

  <ng-container *ngIf="response()?.success">
    <div class="alerts-header">
      <span class="alerts-total">
        {{ totalCount() | number }}
        {{ 'MONITORING.COUNT_LABEL' | translate | lowercase }}
      </span>
      <div class="event-chips">
        <span
          *ngFor="let chip of eventChips()"
          [class]="'event-chip ' + chip.colorClass"
          [title]="chip.label"
        >
          <span
            class="event-chip-icon ui-icon-notifications-sidebar"
            aria-hidden="true"
          ></span>
          {{ chip.label || ('MONITORING.UNKNOWN_EVENT' | translate) }}
          <span class="chip-count">{{ chip.count }}</span>
        </span>
      </div>
      <div class="alerts-header-actions">
        <button
          type="button"
          class="header-open-btn"
          [matTooltip]="(muted() ? 'COMMON.UNMUTE' : 'COMMON.MUTE') | translate"
          (click)="toggleMute()"
        >
          <span [class]="muted() ? 'ui-icon-mute' : 'ui-icon-speaker'"></span>
        </button>
        <button
          type="button"
          class="header-open-btn"
          [matTooltip]="
            'SEARCH_GLOBAL_MODAL.ALERT_CONFIGURATIONS.CREATE_ALERT' | translate
          "
          (click)="openAlertTemplates()"
        >
          <span class="ui-icon-plus"></span>
        </button>
        <button
          type="button"
          class="header-open-btn"
          [matTooltip]="
            'SEARCH_GLOBAL_MODAL.ALERT_MONITORING.OPEN_ALERT_MONITORING'
              | translate
          "
          (click)="openAlertMonitoringPage()"
        >
          <span class="ui-icon-new-tab"></span>
        </button>
      </div>
    </div>

    <div class="am-filters">
      <ui-v2-selector
        class="am-filter-control"
        [options]="eventLookupOptions()"
        [multi]="true"
        searchProperty="name"
        valueProperty="_id"
        [placeholder]="'MONITORING.PLACEHOLDERS.ALERT_SELECTOR' | translate"
        [formControl]="eventSelectorControl"
      ></ui-v2-selector>

      <ui-camera-select-button
        class="am-filter-control"
        [selectedCount]="selectedCameraList().length"
        (click)="openSelectCameraModal()"
      ></ui-camera-select-button>

      <mat-select
        multiple
        class="ui-selector am-filter-control"
        [placeholder]="'MONITORING.PLACEHOLDERS.OBJECT_SELECTOR' | translate"
        panelClass="selector-option-full-width"
        [value]="selectedTrackedObjects()"
        (selectionChange)="onTrackedObjectsChange($event.value)"
      >
        <mat-option [value]="AnalyticClasses.person">
          {{ analyticClassName[AnalyticClasses.person] | translate }}
        </mat-option>
        <mat-option [value]="AnalyticClasses.vehicle">
          {{ analyticClassName[AnalyticClasses.vehicle] | translate }}
        </mat-option>
        <mat-option [value]="AnalyticClasses.weapon">
          {{ analyticClassName[AnalyticClasses.weapon] | translate }}
        </mat-option>
      </mat-select>

      <div class="am-filter-control am-type-filter">
        <step-option-selector
          [multiple]="true"
          [asUiSelector]="true"
          [filterEnabled]="true"
          [optionsGroups]="alertTypeGroupsForSelector()"
          [stringOptions]="true"
          [optionsKeyValuePair]="alertTypeKeyValuePairs()"
          [panelClass]="'alert-type-selector alert-type-selector--wide'"
          [placeholder]="'MONITORING.PLACEHOLDERS.ALERT_TYPE'"
          [ngModel]="selectedFlowTypeKeys()"
          (ngModelChange)="onFlowTypesKeysChange($event)"
        ></step-option-selector>
      </div>

      <app-tag-filter
        class="am-filter-control am-filter-control--narrow"
        [selectWidth]="'100%'"
        [formControl]="tagsFilterControl"
        [isCreateButtonVisibleSig]="false"
      ></app-tag-filter>

      <mat-select
        multiple
        class="ui-selector am-filter-control am-acknowledge-filter"
        [placeholder]="'MONITORING.PLACEHOLDERS.ACKNOWLEDGE' | translate"
        panelClass="selector-option-full-width"
        [value]="selectedAcknowledges()"
        (selectionChange)="onAcknowledgesChange($event.value)"
      >
        <mat-option *ngFor="let option of acknowledgeOptions" [value]="option.value">
          {{ option.label | translate }}
        </mat-option>
      </mat-select>

      <div class="am-filter-control am-date-filter">
        <ui-calendar
          [inputStyle]="inputStyles.noLabel"
          [inputConfig]="{ truncateText: true, minWidthPx: 160 }"
          [selectDateRange]="calendarRange()"
          [maxRetentionDays]="maxRetentionDays()"
          [hoursFormat]="hoursFormat()"
          (rangeSelected)="changeDateRange($event)"
        ></ui-calendar>
      </div>
    </div>

    <div
      class="am-chips"
      *ngIf="
        hasActiveFilters() ||
        (response()?.filter?.resolvedStartTime && response()?.filter?.resolvedEndTime)
      "
    >
      <ui-filter-chip
        *ngFor="let eventId of selectedEventIds()"
        [title]="eventName(eventId)"
        (removeClicked)="onRemoveEvent(eventId)"
      ></ui-filter-chip>

      <ng-container *ngIf="selectedCameraList().length">
        <div [matMenuTriggerFor]="camerasMenu" class="am-camera-chip">
          <ui-filter-chip
            [title]="
              selectedCameraList().length +
              ' ' +
              ('WALL_LIST.CAMERA_FILTER' | translate)
            "
            [allowDelete]="false"
          ></ui-filter-chip>
        </div>
        <mat-menu #camerasMenu="matMenu" xPosition="after" yPosition="below">
          <div class="am-camera-menu">
            <ui-filter-chip
              *ngFor="let camera of selectedCameraList()"
              [title]="cameraLookup()[camera.cameraId]?.edgeOnly?.name"
              [allowDelete]="true"
              (removeClicked)="onRemoveCamera(camera.cameraId)"
            ></ui-filter-chip>
          </div>
        </mat-menu>
      </ng-container>

      <ui-filter-chip
        *ngFor="let trackedObject of selectedTrackedObjects()"
        [title]="analyticClassName[trackedObject] | translate"
        (removeClicked)="onRemoveTrackedObject(trackedObject)"
      ></ui-filter-chip>

      <ui-filter-chip
        *ngFor="let flowType of selectedFlowTypes()"
        [title]="flowName(flowType.category, flowType.flowType) | translate"
        (removeClicked)="onRemoveFlowType(flowType)"
      ></ui-filter-chip>

      <ui-filter-chip
        *ngFor="let tagId of selectedTags()"
        [title]="tagEntities()[tagId]?.name"
        (removeClicked)="onRemoveTag(tagId)"
      ></ui-filter-chip>

      <ui-filter-chip
        *ngFor="let acknowledge of selectedAcknowledges()"
        [title]="
          (acknowledge
            ? 'ACKNOWLEDGE_FILTER.ACKNOWLEDGES'
            : 'ACKNOWLEDGE_FILTER.UNACKNOWLEDGES') | translate
        "
        (removeClicked)="onRemoveAcknowledge(acknowledge)"
      ></ui-filter-chip>

      <ui-filter-chip
        *ngIf="
          response()?.filter?.resolvedStartTime && response()?.filter?.resolvedEndTime
        "
        [title]="
          (response()?.filter?.resolvedStartTime | date: 'medium') +
          ' - ' +
          (response()?.filter?.resolvedEndTime | date: 'medium')
        "
        [allowDelete]="false"
      ></ui-filter-chip>
    </div>

    <div class="am-body">
      <div *ngIf="isFiltering(); else monitoringContent" class="am-filtering">
        <ui-preloader [color]="PreloaderColor.blue" [diameter]="40"></ui-preloader>
      </div>

      <ng-template #monitoringContent>
        <div *ngIf="topCameras().length > 0" class="camera-bars">
          <div *ngFor="let camera of topCameras().slice(0, 4)" class="camera-bar-row">
            <span class="camera-bar-name" [title]="camera.cameraName || camera.cameraId">
              <span class="camera-bar-icon ui-icon-camera" aria-hidden="true"></span>
              <span class="camera-bar-label">{{ camera.cameraName || camera.cameraId }}</span>
            </span>
            <span class="camera-bar-count">{{ camera.count }}</span>
          </div>
        </div>

        <ng-container *ngIf="alerts().length > 0">
          <div
            *ngIf="virtualizationEnabled(); else fallbackAlertList"
            #listWrapper
            class="alert-list-virtual"
            [style.height.px]="virtualizer.getTotalSize()"
          >
            <div
              #virtualRow
              *ngFor="let row of virtualizer.getVirtualItems()"
              class="alert-row"
              [class.alert-row--single]="columns() === 1"
              [attr.data-index]="row.index"
              [style.transform]="'translateY(' + (row.start - listOffset()) + 'px)'"
            >
              <app-alert-preview
                *ngFor="let alert of rows()[row.index]; trackBy: trackByAlert"
                [alert]="alert"
                [cameraPulsationStatus]="cameraStatuses()[alert.cameraId ?? '']?.cameraStatus"
                [cameraLookup]="cameraLookup()"
                [locationLookup]="locationLookup()"
              ></app-alert-preview>
            </div>
          </div>

          <ng-template #fallbackAlertList>
            <div class="alert-list">
              <app-alert-preview
                *ngFor="let alert of alerts(); trackBy: trackByAlert"
                [alert]="alert"
                [cameraPulsationStatus]="cameraStatuses()[alert.cameraId ?? '']?.cameraStatus"
                [cameraLookup]="cameraLookup()"
                [locationLookup]="locationLookup()"
              ></app-alert-preview>
            </div>
          </ng-template>
        </ng-container>

        <div *ngIf="isLoading()" class="alerts-loading">
          <ui-preloader [color]="PreloaderColor.blue" [diameter]="48"></ui-preloader>
        </div>

        <div *ngIf="alerts().length === 0" class="empty-state">
          {{ 'MONITORING.NO_DATA.CAMERA_PAGE_TITLE' | translate }}
        </div>
      </ng-template>
    </div>
  </ng-container>
</div>
